import { useNavigate } from "react-router-dom";
const LOGO_URL = "/logo.png";

const footerLinks = {
  Services: [
    { label: "Tourist Visa", href: "/#visa-search" },
    { label: "Business Visa", href: "/#visa-search" },
    { label: "Compare Visas", href: "/compare" },
    { label: "Visa Calendar", href: "/visa-calendar" },
    { label: "Blog", href: "/blog" },
  ],
  Support: [
    { label: "Track Application", href: "/dashboard" },
    { label: "Pricing", href: "/pricing" },
    { label: "FAQ", href: "/#faq" },
    { label: "Contact Us", href: "#" },
  ],
  Legal: [
    { label: "Terms of Service", href: "/legal/terms" },
    { label: "Privacy Policy", href: "/legal/privacy" },
    { label: "Cookie Policy", href: "/legal/cookies" },
    { label: "Refund Policy", href: "/legal/refund" },
    { label: "Visa Disclaimer", href: "/legal/visa-disclaimer" },
    { label: "Compliance", href: "/legal/compliance" },
  ],
};

export default function Footer() {
  const navigate = useNavigate();
  const handleClick = (e, href) => {
    e.preventDefault();
    if (href.startsWith("/#")) {
      if (window.location.pathname !== "/") { navigate("/"); setTimeout(() => document.querySelector(href.replace("/", ""))?.scrollIntoView({ behavior: "smooth" }), 300); }
      else document.querySelector(href.replace("/", ""))?.scrollIntoView({ behavior: "smooth" });
    } else if (href !== "#") navigate(href);
  };

  return (
    <footer data-testid="footer" className="border-t border-slate-200 bg-white pt-14 pb-8 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-10">
          <div className="col-span-2 md:col-span-1">
            <button onClick={() => navigate("/")} className="mb-4"><img src={LOGO_URL} alt="Fly In Visa" className="h-16 w-auto object-contain rounded-lg" /></button>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">Your trusted partner for seamless visa processing across 120+ countries.</p>
            <p className="text-xs text-slate-400 mt-3">support@flyinvisa.com<br />+91-0000000000</p>
          </div>
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-slate-800 mb-3">{title}</h4>
              <ul className="space-y-2">{links.map(l => (
                <li key={l.label}><a href={l.href} onClick={(e) => handleClick(e, l.href)} className="text-sm text-slate-400 hover:text-blue-600 transition-colors">{l.label}</a></li>
              ))}</ul>
            </div>
          ))}
        </div>

        {/* Disclaimer */}
        <div className="bg-slate-50 rounded-xl p-4 mb-6 border border-slate-100">
          <p className="text-[11px] text-slate-500 leading-relaxed">
            FlyInVisa is an independent visa assistance service provider and is not affiliated with any embassy, consulate, or government authority. Visa approval decisions are solely made by respective immigration authorities. All fees charged are for service assistance and are non-refundable once processing has begun. Government and embassy fees are strictly non-refundable.
          </p>
        </div>

        <div className="border-t border-slate-100 pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-400">&copy; {new Date().getFullYear()} FlyInVisa. All rights reserved.</p>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            {[
              { label: "Terms", href: "/legal/terms" },
              { label: "Privacy", href: "/legal/privacy" },
              { label: "Cookies", href: "/legal/cookies" },
              { label: "Refund", href: "/legal/refund" },
              { label: "Disclaimer", href: "/legal/visa-disclaimer" },
            ].map(l => (
              <a key={l.label} href={l.href} onClick={(e) => { e.preventDefault(); navigate(l.href); }} className="text-xs text-slate-400 hover:text-blue-500">{l.label}</a>
            ))}
          </div>
        </div>

        <p className="text-[10px] text-slate-300 text-center mt-4">By using this website, you agree to our Terms of Service, Privacy Policy, Refund Policy, and Visa Disclaimer.</p>
      </div>
    </footer>
  );
}
